import React from "react"

const ImageScrollZoom = props => {
  return (
    <div className="sectionImage">
      <div
        className="bg-zoom"
        style={{ backgroundImage: "url(" + props.imageSrc + ")" }}
      ></div>
    </div>
  )
}

export default ImageScrollZoom
